import { render, staticRenderFns } from "./form_edit.vue?vue&type=template&id=b4b3bece&scoped=true&"
import script from "./form_edit.vue?vue&type=script&lang=js&"
export * from "./form_edit.vue?vue&type=script&lang=js&"
import style0 from "./form_edit.vue?vue&type=style&index=0&id=b4b3bece&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b3bece",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4b3bece')) {
      api.createRecord('b4b3bece', component.options)
    } else {
      api.reload('b4b3bece', component.options)
    }
    module.hot.accept("./form_edit.vue?vue&type=template&id=b4b3bece&scoped=true&", function () {
      api.rerender('b4b3bece', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/components/form/components/form_edit.vue"
export default component.exports